export default __webpack_public_path__ + "img/thanks.95342b20.svg";